import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_sub_ledger_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  gl_hdr_guid: fromDatatype.GuidDataFieldInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid:  fromDatatype.GuidDataFieldInterface;
  applet_guid:  fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  ledger_hdr_guid:  fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_sub_ledger_hdr_RowClass
  implements bl_fi_sub_ledger_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  gl_hdr_guid: fromDatatype.GuidDataFieldInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid:  fromDatatype.GuidDataFieldInterface;
  applet_guid:  fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  chart_of_acc_guid : fromDatatype.GuidDataFieldInterface;
  gl_code_1 : fromDatatype.VarcharDatatypeInterface;
  gl_code_2 : fromDatatype.VarcharDatatypeInterface;
  gl_code_3 : fromDatatype.VarcharDatatypeInterface;
  gl_code_4 : fromDatatype.VarcharDatatypeInterface;
  name : fromDatatype.VarcharDatatypeInterface;
  descr : fromDatatype.TextDatatypeInterface;
  ledger_hdr_guid:  fromDatatype.GuidDataFieldInterface;
}
